import PropTypes from 'prop-types'

const IconComputer = ({ style }) => {
  return (
    <svg viewBox="0 0 32 32" fill="none" style={style}>
      <mask id="mask_computer" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
        <rect width="32" height="32" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask_computer)">
        <path d="M13.3332 24H5.33317C4.59984 24 3.97206 23.7389 3.44984 23.2167C2.92762 22.6944 2.6665 22.0667 2.6665 21.3333V6.66667C2.6665 5.93333 2.92762 5.30556 3.44984 4.78333C3.97206 4.26111 4.59984 4 5.33317 4H26.6665C27.3998 4 28.0276 4.26111 28.5498 4.78333C29.0721 5.30556 29.3332 5.93333 29.3332 6.66667V21.3333C29.3332 22.0667 29.0721 22.6944 28.5498 23.2167C28.0276 23.7389 27.3998 24 26.6665 24H18.6665L21.1332 26.4667C21.1776 26.5111 21.2443 26.6667 21.3332 26.9333V27.3333C21.3332 27.5111 21.2665 27.6667 21.1332 27.8C20.9998 27.9333 20.8443 28 20.6665 28H11.1332C10.9998 28 10.8887 27.9556 10.7998 27.8667C10.7109 27.7778 10.6665 27.6667 10.6665 27.5333V26.8667C10.6665 26.8222 10.7109 26.7111 10.7998 26.5333L13.3332 24Z" fill="white" fillOpacity="0.8"/>
      </g>
    </svg>
  )
}

IconComputer.propTypes = {
  style: PropTypes.object,
}

export default IconComputer
